<div class="request">
  <div class="container">
    <div class="row">
        <div class="col-12" style="margin-top:0 !important">
            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a routerLink="/dashboard">
                        Inicio
                    </a>
                    </li>
                    <li>
                        <a routerLink="/license/extend">
                        Solicitar
                    </a>
                    </li>
                    <li>
                      <a routerLink="/license/extend">
                        Ampliar licencia
                    </a>
                </ul>
            </div>
        </div>
        <div class="col-12">
          <h2 class="txt txt--title">
            {{variant === 'personal' ? 'Ampliar mi licencia' : 'Ampliar licencia para un empleado o contratista'}}</h2>
        </div>
        <div class="col-12">
          <p class="txt txt--paragraph">A través del siguiente formulario podrás agregar un nuevo equipo, ampliar el tipo de licencias o las zonas registradas en tu licencia.</p>
        </div>
    </div>
  </div>
  <div class="container">
    <div class="mb-4" *ngIf="variant === 'third'">
      <app-person-card [personData]="person || {}" [boxColor]="personBoxColor"></app-person-card>
      <span class="back back--small u-mt10 global-hand" (click)="goBack()">
        Buscar otro conductor
      </span>
    </div>
    <div class="border-b">
      <app-license-card
        *ngIf="license && licenseZones && person"
        [controlForm]="licenseCardVehicleSelectedFormControl"
        [usingAspect]="'EXTEND_LICENSE'"
        [licensesData]="license"
        [zonesRows]="licenseZones"
        [userData]="person"
        [selectedOption]="selectedOption"
      >
      </app-license-card>
    </div>
    <div class="row">
      <div class="request__content col-12" style="margin-top:0 !important">
        <app-new-record
          [license]="license"
          [licenseDetail]="licenseDetail"
          [selectedVehicleControl]="licenseCardVehicleSelectedFormControl"
          (selectOption)="onSelectExtendOption($event)"
          [selectedOption]="selectedOption"
          [equipmentsMergedControl]="equipmentsMergedControl"
        ></app-new-record>

        <app-documents-load
          *ngIf="equipmentsMergedControl.value && licenseDetail && license"
          [documentFormArray]="documentFormArray"
          [requirementId]="this.requirementId"
          [licenseRequirementId]="this.license.requirementId"
          [equipmentDataToSend]="equipmentsMergedControl.value"
          [assetId]="this.licenseDetail.assetId"
          [driverMdmId]="this.licenseDetail.driverMdmid"
          [driverIsEmployee]="this.selectedPersonIsEmployee"
          [canReuseOldDocuments]="true"
          numberSection="2"
        ></app-documents-load>

        <div class="textWarningFillDocumentContainer">
          <p class="textWarningFillDocument">
            {{ this.documentFormArray.errors ? this.documentFormArray.errors.description : ' '}}
            &nbsp;
          </p>
        </div>

        <app-form-employee
          *ngIf="selectedPersonIsEmployee"
          [isEmployee]="true"
          [assetId]="license?.asset?.id"
          [enabled]="this.documentFormArray.valid"
          [controlForm]="employeeFormControl"
          [numberSection]="!equipmentsMergedControl.value ? '2' : '3' "
          ></app-form-employee>

        <app-form-contract-owner-selector
          *ngIf="!selectedPersonIsEmployee"
          [enabled]="documentFormArray.valid "
          [numberSection]="2"
          (personSelected)="onSetContractOwner($event)"
        >
        </app-form-contract-owner-selector>

        <div class="border-b"></div>
        <div class="request__step mt-4" [ngClass]="this.documentFormArray.valid ? '' : 'u-lock'">
          <div
            class="request__send "

          >
            <div class="form">
              <div class="form__check">
                <input type="checkbox" name="checkbox" value="agree-terms" id="agree-terms" [formControl]="agreeTerms">
                <label for="agree-terms">
                  <div class="fakebox fakebox--grey"></div>
                  <span>&nbsp;</span>
                </label>
                <span class="spanTerm-aconditions ">
                  Confirmo que he leído los <a (click)="showModalConfirmTermsAndConditions()"
                    class="no-padding hover-hand" data-modal="modal01">términos y
                    condiciones</a> y doy fe de la veracidad de los documentos ingresados para evitar sanciones
                  asociadas.
                </span>
              </div>

            </div>
            <div class="buttons u-mt20">
              <div class="row">
                <div class="col-md-3 order-md-1 order-2">
                  <a class="btn btn--link" (click)="showCancelModal()">Cancelar solicitud</a>
                </div>
                <div class="col-md-9 order-md-2 order-1">
                  <button type="button" class="btn btn--primary modal__trigger" (click)="showConfirmationModal()"
                    [attr.disabled]="shouldEnableSubmit ? null : true">Enviar
                    formulario
                  </button>
                </div>

              </div>
              <!-- <div class="textWarningFillDocumentContainer">
                <p class="textWarningFillDocument">
                  {{ !newEquipmentForm.valid && agreeTerms.value ? 'Para enviar el formulario debe completar todos los campos requeridos.' : ' '}}
                  &nbsp;
                </p>
              </div> -->
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
